import {RouteNameEnum} from "@/v2/enumerate/route";

const info = [{
	path: "info",
	name: RouteNameEnum.GLORY_INFO,
	meta: {
		permission: 62001,
		breadcrumb: [{
			key: "glory.info.index",
			value: null
		}]
	},
	component: () => import("@/page/content/glory/info/index.vue"),
}];

export default info;
